import { supabase } from '@/supabase';
import type { Department, Employee } from '~/types';
import { 
    useAppStore,
    useAuthStore } from '#imports';
const crypto = Number(import.meta.env.VITE_CRYPTO);

export const useEmployeeStore = defineStore('employeeStore', () => {
    const { txt } = storeToRefs(useAppStore());
    const { active_emp, active_emp_id, currentLocationId, isDemo, profile } = storeToRefs(useAuthStore());
    const _isPending = ref<boolean>(false);
    const employees = ref<Array<any>>([]);
    const employee = ref<any>({});
    const employees_cnt = ref<number>(0);
    const emp_stati = ref<Array<any>>([
        { title: txt.value.employee_.status['1'], value: 1 },
        { title: txt.value.employee_.status['2'], value: 2 },
        { title: txt.value.employee_.status['3'], value: 3 }
    ]);

    const isPending = computed(() => { return _isPending.value });
    
    const params = ref<any>({
        isAsc: true,
        orderBy: 'id',
        page: 1,
        perPage: Number.MAX_SAFE_INTEGER,
        search: ''
    });

    const blankEmployee = computed(() => { return { id: 0, fname: '', lname: '', full_name: '', wage: 0, start: null, end: null, location: {} as Location, department: {} as Department, sort_order: 1, shifts: [], code: '', role: { id: 4, name: txt.value.roles[4] } } as Employee; });
    const startIndex = computed(() => { return (params.value.page - 1) * params.value.perPage; });
    const endIndex = computed(() => { return startIndex.value + params.value.perPage - 1 });

    function $reset(): void {
        employees.value = [];
        employee.value = {};
        employees_cnt.value = 0;
        _isPending.value = false;
        params.value = {
            isAsc: true,
            orderBy: 'id',
            page: 1,
            perPage: Number.MAX_SAFE_INTEGER,
            search: ''
        };
    }

    async function fetchEmployees(location_id: number, fetchAll: boolean = false, status: number = 1): Promise<string> {
        console.log(`fetchEmployees(location_id: ${location_id}, fetchAll: ${fetchAll})`);
        /*if (!isAdmin.value) {
            employees.value = [active_emp.value];
            employees_cnt.value = 1;
            return '';
        }

        if (_isPending.value || !profile.value) return 'Error:  Please try again';
        */_isPending.value = true;

        let msg = '';

        let query = 
        isDemo.value
        ? supabase
            .from('employee_demo')
            .select('id, fname, lname, wage, location_demo:location_id(*), department_demo:dept_id(*), code, profile_demo:account_id(email, phone), role:role_id(*), start, end, sort_order, availability_code, account_id, creator_id, status', { count: 'exact', head: false })
            .eq('location_id', location_id)
        : supabase
            .from('employee')
            .select('id, fname, lname, wage, location:location_id(*), department:dept_id(*), code, profile:account_id(email, phone), role:role_id(*), start, end, sort_order, availability_code, account_id, creator_id, status', { count: 'exact', head: false })
            .eq('location_id', location_id);

        if (fetchAll) {
            query = query.order('fname', { ascending: true })
            .order('lname', { ascending: true })
        }
        else {
            query = query.order(params.value.orderBy, { ascending: params.value.isAsc })
            .range(startIndex.value, endIndex.value);
        }

        const { data, count, error } = await query.eq('status', status);

        if (error) {
            msg = error.message as string;
        }
        else if (data) {
            console.log('emp data:', data)
            employees.value = data.map(d => { return {
                ...d,
                wage: Number(`0x${d.wage}`) / 100 - (Number(`0x${d.code.substring(1, 5)}`) * crypto),
                full_name: `${d.fname} ${d.lname}`,
                location: isDemo.value ? d.location_demo : d.location,
                department: isDemo.value ? d.department_demo : d.department,
                profile: isDemo.value ? d.profile_demo : d.profile
            }; });
            employees_cnt.value = count || 0;
        }

        if (!employee.value) {
            employee.value = blankEmployee.value;
        }

        _isPending.value = false;
        return msg;
    }

    async function addUpdateEmployee(employee: any): Promise<string> {
        if (isDemo.value) {
            return 'The setup section cannot be modified in demo mode.';
        }

        if (_isPending.value) return 'Error:  Please try again';
        _isPending.value = true;

        let msg = '';

        let query = null;

        if (employee.id === 0) {
            query = supabase
                .from(isDemo.value ? 'employee_demo' : 'employee')
                .insert([
                    {
                        created_at: new Date().toISOString(),
                        fname: employee.fname,
                        lname: employee.lname,
                        wage: Math.floor((employee.wage + Number(`0x${employee.code.substring(1, 5)}`) * crypto) * 100).toString(16),
                        location_id: currentLocationId.value,
                        code: employee.code,
                        role_id: employee.code[0] === 'L' ? 2 : 4,
                        start: employee.start,
                        end: employee.end,
                        sort_order: employee.sort_order,
                        dept_id: employee.department ? employee.department.id : null,
                        availability_code: employee.availability_code ? employee.availability_code : '1111111',
                        status: employee.status ? employee.status : 1
                    }
                ])
                .select();
        }
        else {
            query = supabase
                .from(isDemo.value ? 'employee_demo' : 'employee')
                .update([
                    {
                        fname: employee.fname,
                        lname: employee.lname,
                        wage: Math.floor((employee.wage + Number(`0x${employee.code.substring(1, 5)}`) * crypto) * 100).toString(16),
                        location_id: employee.location_id,
                        role_id: employee.role_id,
                        start: employee.start,
                        end: employee.end,
                        sort_order: employee.sort_order,
                        dept_id: employee.department ? employee.department.id : null,
                        availability_code: employee.availability_code ? employee.availability_code : '1111111',
                        status: employee.status ? employee.status : 1
                    }
                ])
                .eq('id', employee.id)
                .select();
        }

        const { data, error } = await query;

        if (error) {
            msg = error.message as string;
        }
        else if (data) {
            console.log(employee)
            console.log(`add/update: ${employee.wage} + ${Number(`0x${employee.code.substring(1, 3)}`)} = ${employee.wage + Number(`0x${employee.code.substring(1, 3)}`)}`)
        }

        _isPending.value = false;
        return msg;
    }

    async function deleteEmployee(id: number): Promise<string> {
        if (_isPending.value) return 'Error:  Please try again';
        _isPending.value = true;

        let msg = '';

        const { error } = await supabase
            .from(isDemo.value ? 'employee_demo' : 'employee')
            .delete()
            .eq('id', id);

        if (error) {
            msg = error.message as string;
        }

        _isPending.value = false;
        return msg;
    }

    async function redeemEmployeeCode(code: string): Promise<string> {
        if (isDemo.value) {
            return 'Link codes cannot be redeemed in demo mode.';
        }
        if (_isPending.value) return 'Error:  Please try again';
        _isPending.value = true;

        let msg = '';

        const { data, error } = await supabase
            .from('employee')
            .update([{ account_id: profile.value.account_id }])
            .is('account_id', null)
            .eq('code', code.toUpperCase())
            .select('id, location_id');

        if (error) {
            msg = error.message as string;
        }
        else if (data) {
            if (!data[0]) {
                msg = 'Invalid Link Code';
            }
            else {
                active_emp_id.value = data[0].id;
                currentLocationId.value = data[0].location_id;
            }
        }

        _isPending.value = false;
        return msg;
    }

    function createCode(location_id: number = 0) {
        let date = Date.now().toString().substring(5);
        let code = '';

        while (date.length > 2) {
            let num = date.substring(0, 4);
            date = date.substring(4);
            code += Number(num).toString(16);
        }

        if (date.length > 0) {
            code += Number(date).toString(16);
        }

        if (location_id > 0) {
            code += location_id.toString(16);
        }
        else {
            code = "L" + code;
        }

        console.log('code:', code.toUpperCase())
        return code.toUpperCase();
    }

    return {
        blankEmployee,
        emp_stati,
        employees,
        employee,
        employees_cnt,
        params,
        isPending,
        addUpdateEmployee,
        createCode,
        deleteEmployee,
        fetchEmployees,
        redeemEmployeeCode,
        $reset
    }
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useEmployeeStore, import.meta.hot))
}